(function () {
  'use strict';

  function prefersReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function initAccordion(root) {
    var accordion = root.querySelector('[data-rtp-s5-accordion]');
    if (!accordion) return;

    var items = Array.prototype.slice.call(accordion.querySelectorAll('[data-rtp-s5-item]'));

    function getParts(item) {
      return {
        trigger: item.querySelector('[data-rtp-s5-trigger]'),
        panel: item.querySelector('[data-rtp-s5-panel]')
      };
    }

    function closeItem(item, instant) {
      var parts = getParts(item);
      if (!parts.trigger || !parts.panel) return;
      if (parts.trigger.getAttribute('aria-expanded') !== 'true') return;

      parts.trigger.setAttribute('aria-expanded', 'false');
      parts.panel.classList.remove('is-open');

      if (instant || prefersReducedMotion()) {
        parts.panel.style.height = '0px';
        parts.panel.style.opacity = '0';
        parts.panel.hidden = true;
        return;
      }

      parts.panel.style.height = parts.panel.scrollHeight + 'px';
      // Force reflow
      void parts.panel.offsetHeight;
      parts.panel.style.height = '0px';
      parts.panel.style.opacity = '0';

      var onEnd = function (ev) {
        if (ev.propertyName !== 'height') return;
        parts.panel.removeEventListener('transitionend', onEnd);
        if (parts.trigger.getAttribute('aria-expanded') === 'false') {
          parts.panel.hidden = true;
        }
      };
      parts.panel.addEventListener('transitionend', onEnd);
    }

    function openItem(item, instant) {
      var parts = getParts(item);
      if (!parts.trigger || !parts.panel) return;

      // Close others first (one-open-at-a-time)
      items.forEach(function (other) {
        if (other !== item) closeItem(other, instant);
      });

      parts.trigger.setAttribute('aria-expanded', 'true');
      parts.panel.hidden = false;
      parts.panel.classList.add('is-open');

      if (instant || prefersReducedMotion()) {
        parts.panel.style.height = 'auto';
        parts.panel.style.opacity = '1';
        return;
      }

      parts.panel.style.height = '0px';
      parts.panel.style.opacity = '0';
      void parts.panel.offsetHeight;
      parts.panel.style.height = parts.panel.scrollHeight + 'px';
      parts.panel.style.opacity = '1';

      var onEnd = function (ev) {
        if (ev.propertyName !== 'height') return;
        parts.panel.removeEventListener('transitionend', onEnd);
        if (parts.trigger.getAttribute('aria-expanded') === 'true') {
          parts.panel.style.height = 'auto';
        }
      };
      parts.panel.addEventListener('transitionend', onEnd);
    }

    function toggleItem(item) {
      var parts = getParts(item);
      if (!parts.trigger) return;
      var open = parts.trigger.getAttribute('aria-expanded') === 'true';
      if (open) {
        closeItem(item, false);
      } else {
        openItem(item, false);
      }
    }

    items.forEach(function (item) {
      var parts = getParts(item);
      if (!parts.trigger || !parts.panel) return;

      // Initial closed state
      parts.trigger.setAttribute('aria-expanded', 'false');
      parts.panel.hidden = true;
      parts.panel.style.height = '0px';
      parts.panel.style.opacity = '0';
      parts.panel.classList.remove('is-open');

      parts.trigger.addEventListener('click', function () {
        toggleItem(item);
      });
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-rtp-s5]');
    Array.prototype.forEach.call(roots, initAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
